// extracted by mini-css-extract-plugin
export default {"Image":"ImageModal_Image__eLB1a","ModalBody":"ImageModal_ModalBody__CMe9e","ButtonContainer":"ImageModal_ButtonContainer__vEq5w"};